import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import MailIcon from '@mui/icons-material/Mail';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box } from '@mui/material';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import React from 'react';
export default function BadgeExample() {
    const [count, setCount] = React.useState(1);
    const [invisible, setInvisible] = React.useState(false);
    const handleBadgeVisibility = () => {
        setInvisible(!invisible);
    };
    return (_jsxs(Box, Object.assign({ sx: {
            display: 'flex',
            flexDirection: 'column',
            '& > *': {
                mb: 2,
            },
            '& > div > span': {
                mr: 4,
            },
        } }, { children: [_jsxs("div", { children: [_jsx(Badge, Object.assign({ color: "primary", badgeContent: count }, { children: _jsx(MailIcon, {}) })), _jsx(Badge, Object.assign({ color: "secondary", badgeContent: count }, { children: _jsx(MailIcon, {}) })), _jsx(Badge, Object.assign({ color: "error", badgeContent: count }, { children: _jsx(MailIcon, {}) })), _jsxs(ButtonGroup, { children: [_jsx(Button, Object.assign({ "aria-label": "reduce", onClick: () => {
                                    setCount(Math.max(count - 1, 0));
                                } }, { children: _jsx(RemoveIcon, { fontSize: "small" }) })), _jsx(Button, Object.assign({ "aria-label": "increase", onClick: () => {
                                    setCount(count + 1);
                                } }, { children: _jsx(AddIcon, { fontSize: "small" }) }))] })] }), _jsxs("div", { children: [_jsx(Badge, Object.assign({ color: "primary", variant: "dot", invisible: invisible }, { children: _jsx(MailIcon, {}) })), _jsx(Badge, Object.assign({ color: "secondary", variant: "dot", invisible: invisible }, { children: _jsx(MailIcon, {}) })), _jsx(Badge, Object.assign({ color: "error", variant: "dot", invisible: invisible }, { children: _jsx(MailIcon, {}) })), _jsx(FormControlLabel, { control: _jsx(Switch, { color: "primary", checked: !invisible, onChange: handleBadgeVisibility }), label: "Show Badge" })] })] })));
}
